import { ChangeEvent, CSSProperties, ReactNode } from "react";

import cx from "classnames";
import styled from "styled-components";

const CheckRadioContainer = styled.div`
  &&& {
    > input + label {
      margin: 0.5em;
    }
  }
`;

interface CheckRadioProps {
  id: string;
  checked: boolean;
  children?: ReactNode;
  disabled?: boolean;
  type?: string;
  className?: string;
  labelStyle?: CSSProperties;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const CheckRadio = ({
  id,
  checked,
  children,
  disabled,
  type = "checkbox",
  className,
  labelStyle,
  onChange
}: CheckRadioProps) => {
  return (
    <CheckRadioContainer className="field" data-testid={`checkradio-${id}`}>
      <input
        id={id}
        name={id}
        type={type}
        disabled={disabled}
        onChange={onChange}
        checked={checked}
        className={cx("is-checkradio", className)}
      />

      <label htmlFor={id} style={labelStyle}>
        {children}
      </label>
    </CheckRadioContainer>
  );
};

export default CheckRadio;
